import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dbg",
  "use": "icon-dbg-usage",
  "viewBox": "0 0 2432 104",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2432 104\" id=\"icon-dbg\">\r\n  <g transform=\"matrix(1 0 0 1 611 -606 )\">\r\n    <path d=\"M 2432 104  L 1 104  L 1 66.0689655172414  C 1 66.0689655172414  179.620689655172 0.551724137931046  327.896551724138 0.551724137931046  C 476.172413793104 0.551724137931046  683.068965517241 67.9310344827586  858.931034482759 67  C 1034.79310344828 66.0689655172414  1176.02567865004 -0.768892149669909  1476.1724137931 0.551724137931046  C 1776.31914893617 1.872340425532  1793.41379310345 68  1921 68  C 2048.58620689655 68  2193.41379310345 0.551724137931046  2283.06896551724 0.551724137931046  C 2372.72413793103 0.551724137931046  2431.34482758621 68  2431.34482758621 68  L 2432 104  Z \" fill-rule=\"nonzero\" fill=\"#ffffff\" stroke=\"none\" transform=\"matrix(1 0 0 1 -611 606 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dbg.svg
// module id = Z4Wi
// module chunks = 0